// extracted by mini-css-extract-plugin
export default {"date":"styles_date__4gDUO","name":"styles_name__xRQLF","number":"styles_number__hnoWY"};